// @flow
import React, { Component } from "react";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";
import { WhiteText, SecondaryGreen, GreyText, ThirdGreen, InvalidText } from "../../../global/uis/scss";

const styles = theme => ({
  chip: {
    backgroundColor: ThirdGreen,
    marginLeft: "2px",
    color: WhiteText,
    fontSize: "0.875rem",
  },
});

type CompanyNameReminderPropsType = {
  classes: { [key: string]: string },
  label: string
};

class CompanyNameReminder extends Component<CompanyNameReminderPropsType, *> {
  render(): * {
    const classes = this.props.classes;
   
    return (
      <Chip label={this.props.label} className={classes.chip} />
    );
  }
}

export default withStyles(styles)(CompanyNameReminder);  